import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Policy/PolicyNotifications.Controller.ts

/** Wire DTOs — mirror apps/server/src/API/Policy/PolicyNotifications.Service.ts. */

export interface PolicyNotificationViewDTO {
  id: number;
  createdAt: string;
  updatedAt: string;
  policyKey: string;
  revision: number;
  releaseNote: string;
  title: string;
  sentAt?: string | null;
  sentByAccountId?: number | null;
  /** Pending items only: how many flagged orgs a release would ticket. */
  blastRadius?: number;
}

export interface PolicyNotificationsResponseDTO {
  pending: PolicyNotificationViewDTO[];
  sent: PolicyNotificationViewDTO[];
}

export interface ReleaseNotificationResponseDTO {
  ok: boolean;
  ticketsCreated?: number;
  error?: string;
}

export class PolicyNotificationsAPI {
  static async getNotifications(): Promise<PolicyNotificationsResponseDTO> {
    return APIService.Server.get<PolicyNotificationsResponseDTO>(`/policy-notifications`);
  }

  static async release(id: number): Promise<ReleaseNotificationResponseDTO> {
    return APIService.Server.post<ReleaseNotificationResponseDTO>(`/policy-notifications/${id}/send`, {});
  }
}
